import { ISavedSearchItem } from "../save-search.types";
import { mapSavedSearchList } from "./mapSavedSearchList";
import getEnvironment from "../../getEnvironment";

const getSavedSearches = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<ISavedSearchItem[] | any> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while fetching the data.`
    );
  }

  const result = await res.json();

  if (result.degradedServices?.length > 0) {
    return { degradedServices: result.degradedServices };
  }

  return mapSavedSearchList(result);
};

export default getSavedSearches;
